import { render, staticRenderFns } from "./StatisticByBookingTrainingCourse.vue?vue&type=template&id=367a9366&scoped=true"
import script from "./StatisticByBookingTrainingCourse.vue?vue&type=script&lang=ts"
export * from "./StatisticByBookingTrainingCourse.vue?vue&type=script&lang=ts"
import style0 from "./StatisticByBookingTrainingCourse.vue?vue&type=style&index=0&id=367a9366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a9366",
  null
  
)

export default component.exports